<!-- OPPO点击监测用户 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 0 0 0;">
			<div class="screen-box">
				<div class="screen-label">投放日期</div>
				<a-range-picker style="width:300px;" @change="onChangeDate" :allowClear="false"
				:locale="locale" 
				:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">点击日期</div>
				<a-range-picker style="width:300px;" @change="onChangeDateB" :allowClear="false"
				:locale="locale" allowClear 
				:value="[show_click_start,show_click_end]" />
			</div>
			
			
			<div class="screen-box">
				<div class="screen-label">ID</div>
				<a-input v-model="r_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">广告ID</div>
				<a-input v-model="r_ad_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">广告名称</div>
				<a-input v-model="r_ad_name" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">Imei</div>
				<a-input v-model="r_imei" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">Oaid</div>
				<a-input v-model="r_oaid" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">文鼎推广链接Id</div>
				<a-input v-model="r_link_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">是否匹配上注册用户</div>
				<a-select style="width: 160px;" 
				 @change="handleChangeD" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div>
			
			
			
			<a-button @click="searchButton('button')" :loading="search_button_loading" class="screen-box" type="primary" icon="search">搜索</a-button>
			<!-- <a-button @click="exportButton" type="primary" icon="download" class="screen-box" >导出</a-button> -->
		</div>
	</div>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell"
				:style="{'width':rableTitle[0].width + 'px'}" >
					{{rableTitle[0].title}}
				</div>
				<div class="table-th-cell"
				:style="{'width':rableTitle[1].width + 'px'}" >
					{{rableTitle[1].title}}
				</div>
				
			</div>
			<div v-for="(item,index) in rableTitle" :key="index" >
				<div v-if="index > 1" class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<!-- ID -->
				<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
					{{item.id}}
				</div>
				<!-- 日期 -->
				<div class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
					{{item.date_key}}
				</div>
			</div>
			<!-- Oaid -->
			<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
				<div v-if="item.OAID">
					<a-popover placement="top">
						<template slot="content">
						  <p style="width: 280px;word-break: break-all;">{{item.OAID}}</p>
						</template>
						<div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;height: 39px;">
							{{item.OAID}}
						</div>
					</a-popover>
				</div>
				<div v-else>{{item.OAID}}</div>
			</div>
			<!-- Imei -->
			<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}">
				{{item.imei}}
			</div>
			<!-- 运营商 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}">
				{{item.carrier}}
			</div>
			<!-- 操作系统 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[5].width + 'px'}">
				{{item.os}}
			</div>
			<!-- 广告ID -->
			<div  class="table-td-cell" :style="{'width':rableTitle[6].width + 'px'}">
				{{item.ad_id}}
			</div>
			<!-- 广告名称 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[7].width + 'px'}">
				{{item.ad_name}}
			</div>
			<!-- 请求唯一串 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[8].width + 'px'}">
				
				<a-popover placement="top">
					<template slot="content">
					  <p style="width: 280px;word-break: break-all;">{{item.req_id}}</p>
					</template>
					<div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;height: 39px;">
						{{item.req_id}}
					</div>
				</a-popover>
			</div>
			<!-- 文鼎推广链接Id -->
			<div  class="table-td-cell" :style="{'width':rableTitle[9].width + 'px'}">
				{{item.link_id}}
			</div>
			<!-- 是否匹配上注册用户 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[10].width + 'px'}">
				
				<div v-if="item.has_register == 1" style="background-color: #21b978;color: #fff;width: 27px;height: 24px;text-align: center;line-height: 24px;border-radius: 3px;">是</div>
				<div v-else style="background-color: #62a8ea;color: #fff;width: 27px;height: 24px;text-align: center;line-height: 24px;border-radius: 3px;">否</div>
			</div>
			<!-- 创建时间 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[11].width + 'px'}">
				{{item.created_at}}
			</div>
			
			
		</div>
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_null_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<!-- 分页 -->
		<!-- <div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 41px;"> -->
			<div style="text-align: center;margin-top: 30px;position: sticky;left: 30px;" :style="{'width': table_null_width + 'px',}">
				<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" :showTotal="(total, range) => `共 ${total} 条`" @change="paginationChange" hideOnSinglePage/>
			</div>
		<!-- </div> -->
	</div>
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { putDataMenu, clickOppoList, LdJmyReport, orderGzhCustomReport,  } from '@/request/api'
export default {
	name: 'clickOPPO_',
	components: {
		
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2022-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			filterList: { // 搜索条件内容
				channel_id: {},
				gzh_id: {},
			}, 
			click_start_date: '', // 点击日期
			click_end_date: '', // 点击日期
			show_click_start: '', // 点击日期开始
			show_click_end: '', // 点击日期结束
			
			
			is_admin: false, // 为true表示 超级管理员
			is_super: false, // 为true表示放管理
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:80, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"日期", width:100, type:"date_key", },
				{title:"Oaid", width:180, type:"OAID", },
				{title:"Imei", width:180, type:"imei", },
				{title:"运营商", width:120, type:"carrier", },
				{title:"操作系统", width:100, type:"os", },
				{title:"广告ID", width:100, type:"ad_id", },
				{title:"广告名称", width:160, type:"ad_name", },
				{title:"请求唯一串", width:160, type:"req_id", },
				{title:"文鼎推广链接Id", width:120, type:"link_id", },
				{title:"是否匹配上注册用户", width:150, type:"has_register", },
				{title:"创建时间", width:150, type:"created_at", },
				
				// {title:"操作", width:160, type:"cz", },
			],
			tableShowData: [],
			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			search_button_loading: false, // 搜索按钮的加载状态
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			
			
			r_id: "", // ID
			r_ad_id: "", // 广告ID
			r_ad_name: "", // 广告名称
			r_imei: "", // Imei
			r_oaid: "", // Oaid
			r_link_id: "", // 文鼎推广链接Id
			r_has_register: undefined, // 是否匹配上注册用户。0为否。1为是
			
			hc_id: "", // 手动回传id
			hc_visible: false, // 手动回传弹窗
			hc_confirm_loading: false, 
			hc_Zdy_visible: false, 
			hc_Zdy_loading: false,
			h_report_id: "", // 落地页用户ID
			h_report_id_type: undefined, // 落地页用户类型
		}
	},
	mounted(){
		let that = this
		
		that.search_button_loading = true
		
		that.body_width = document.body.clientWidth // 筛选条件大盒子的宽度
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30
		if(that.table_scroll_width >= that.body_width){ that.table_null_width = that.body_width - 60 }
		else { that.table_null_width = that.table_scroll_width - 60 }
		
		setTimeout(()=>{
			// 给母页面的tab传递粘性定位用的参数
			that.$bus.$emit("stickyData", that.table_scroll_width);
		},300)
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		
		// 获取7天前日期
		// that.startTime = this.$getBeforeDay(6)
		
		// 获取当前日期
		that.endTime = this.$getThisDay()
		that.startTime = this.$getThisDay()

		// 搜索
		that.searchButton()
			
		
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		// 点击日期
		onChangeDateB(date, dateString){
			console.log('点击日期',date, dateString);
			if(dateString[0]){
				this.show_click_start = this.moment(dateString[0], this.dateFormat) || '' // 点击日期开始
				this.show_click_end = this.moment(dateString[1], this.dateFormat) || '' // 点击日期结束
			}
			else {
				this.show_click_start =  '' // 点击日期开始
				this.show_click_end =  '' // 点击日期结束
			}
			
			
			this.click_start_date = dateString[0]
			this.click_end_date = dateString[1]
		},
		
		handleChangeD(e){ // 是否匹配上注册用户
			console.log(e);
			this.r_has_register = e
		},
		
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			let s_date,e_date
			if(that.click_start_date){
				s_date = that.click_start_date + ' 00:00:00'
				e_date = that.click_end_date + ' 23:59:59'
			}
			else {
				s_date = ""
				e_date = ""
			}
			
			// 点击按钮进行条件搜索的时候，要把页数变成1，否则相关内容可能搜索不出来。
			if(type == 'button'){
				that.r_page = 1
			}
			
			let r_data = {
				limit: that.r_limit,
				page: that.r_page,
				start_date_key: that.startTime.replace(/-/g, ''),
				end_date_key: that.endTime.replace(/-/g, ''),
				
				has_register: that.r_has_register, // 是否匹配上注册用户。0为否。1为是
			}
			
			if(s_date){
				r_data.start_click_time = s_date
				r_data.end_click_time = e_date
			}
			if(that.r_id){ r_data.id = that.r_id } // ID
			if(that.r_ad_id){ r_data.ad_id = that.r_ad_id } // 广告ID
			if(that.r_ad_name){ r_data.ad_name = that.r_ad_name } // 广告名称
			if(that.r_imei){ r_data.imei = that.r_imei } // Imei
			if(that.r_oaid){ r_data.oaid = that.r_oaid } // Oaid
			if(that.r_link_id){ r_data.link_id = that.r_link_id } // 文鼎推广链接Id
			
			clickOppoList(r_data).then(res=>{
				console.log('搜索',res);
				that.search_button_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					// that.is_super = res.data.data.is_super // 是否是投放管理员
					
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton()
		},
		
	}
	
}
</script>

<style scoped>
.table-td-cell {
	font-size: 13px;
}
</style>